<template>
  <div>
    <DialogBase
      title="Danh sách học sinh"
      :visible.sync="isStudentChangeOnlinePaymentDialog"
      width="1100px"
      panel-icon="el-icon-user"
      panel-title="DANH SÁCH HỌC SINH"
      panel-subtitle="Danh sách chi tiết học sinh ghi nhận thay đổi hạn mức trong kỳ."
      :show-confirm="false"
      cancel-text="Đóng hộp thoại"
      @before-close="handleClose"
      @cancel="handleClose"
      @open="handleOpen"
    >
      <div class="dialog-inner-body">
        <el-table
          ref="multipleTable"
          v-loading="loadingData"
          element-loading-text="Đang tải danh sách học sinh..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.7)"
          :data="studentList"
          highlight-current-row
          class="modern-table"
          border
          :max-height="tableMaxHeight"
        >
          <el-table-column type="index" label="STT" width="55" align="center" fixed />

          <el-table-column prop="kidCode" label="Mã học sinh" width="140" align="center" fixed>
            <template slot-scope="{ row }">
              <code class="code-badge">{{ row.kidCode }}</code>
            </template>
          </el-table-column>

          <el-table-column label="Họ và tên học sinh" prop="name" min-width="180" fixed>
            <template slot-scope="{ row }">
              <span class="student-name">{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Giới tính" prop="gender" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="row.gender === 'Nữ' ? 'danger' : 'primary'" size="medium" effect="plain">
                {{ row.gender }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Lớp học" prop="className" min-width="150" align="center">
            <template slot-scope="{ row }">
              <span class="class-text">{{ row.className }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Khối học" prop="gradeName" min-width="150" align="center">
            <template slot-scope="{ row }">
              <span class="grade-text">{{ row.gradeName }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper mt-3 flex justify-center">
          <el-pagination
            background
            :current-page="pageNumber"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="$pageListDefaultUser || [10, 20, 50, 100]"
            :page-size="maxPageItem"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          />
        </div>
      </div>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import sePayConnectionService from "@/services/SePayConnectionService";

export default {
  name: "StudentChangeOnlinePaymentDialog",
  components: { DialogBase },
  props: {
    isStudentChangeOnlinePaymentDialog: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: () => ""
    },
    idHistory: {
      type: Number,
      default: () => 0
    },
    typeUser: {
      type: String,
      default: () => ""
    },
    idSchool: {
      type: Number,
      default: () => 0
    }
  },

  data() {
    return {
      studentList: [],
      textTable: "",
      loadingData: true,
      pageTotal: 0,
      maxPageItem: 10,
      pageNumber: 1
    };
  },

  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 500;
    }
  },

  methods: {
    handleClose() {
      this.pageNumber = 1;
      this.$emit("closeDialog");
    },
    
    handleOpen() {
      this.searchByProperties();
    },
    
    handleSizeChange(maxPageItem) {
      this.maxPageItem = maxPageItem;
      this.pageNumber = 1;
      this.searchByProperties();
    },
    
    handleCurrentChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.searchByProperties();
    },
    
    searchByProperties() {
      this.loadingData = true;
      if (this.$props.typeUser === "plus") {
        sePayConnectionService
          .findKidsChangeOnlinePayment(this.$props.idHistory, this.$props.type, this.maxPageItem, this.pageNumber)
          .then((resp) => {
            this.studentList = resp.data.data.kidsChangeResponseList || [];
            this.pageTotal = resp.data.data.total || 0;
          })
          .catch((err) => {
            this.pageTotal = 0;
            this.studentList = [];
            console.error(err);
          })
          .finally(() => {
            this.loadingData = false;
          });
      } else {
        sePayConnectionService
          .findKidsChangeOnlinePaymentAdmin(
            this.$props.idHistory,
            this.$props.type,
            this.maxPageItem,
            this.pageNumber,
            this.$props.idSchool
          )
          .then((resp) => {
            this.studentList = resp.data.data.kidsChangeResponseList || [];
            this.pageTotal = resp.data.data.total || 0;
          })
          .catch((err) => {
            this.pageTotal = 0;
            this.studentList = [];
            console.error(err);
          })
          .finally(() => {
            this.loadingData = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 8px 0;
  }
}

.code-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #475569;
  border: 1px solid #cbd5e1;
}

.student-name {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
}

.class-text {
  font-weight: 600;
  color: #2563eb;
}

.grade-text {
  font-weight: 600;
  color: #475569;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.mt-3 { margin-top: 12px; }
.flex { display: flex; }
.justify-center { justify-content: center; }
</style>